export enum EventSource {
  PRIMARY,
  TRAILING,
  NONE,
}
